import { render, staticRenderFns } from "./NominationDisqualified.vue?vue&type=template&id=bc538aae&scoped=true"
import script from "./NominationDisqualified.vue?vue&type=script&lang=js"
export * from "./NominationDisqualified.vue?vue&type=script&lang=js"
import style0 from "./NominationDisqualified.vue?vue&type=style&index=0&id=bc538aae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc538aae",
  null
  
)

export default component.exports